/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';

import cx from 'classnames';

import { useTeamPage } from 'hooks/page/team/useTeamPage';

import { ClassicTeamMember } from './components/ClassicTeamMember';

import s from './ClassicTeam.module.css';

export const ClassicTeam = () => {
  const { professionals, handleBook } = useTeamPage();

  return (
    <div className={cx(s.root)}>
      <div className={s.servicesHeaderWrap}>
        <h1 className={cx(s.title)}>Team</h1>
      </div>
      <ul className={s.list}>
        {professionals.map((member) => (
          <li className={s.item} key={member.guid}>
            <ClassicTeamMember professional={member} onClick={handleBook} />
          </li>
        ))}
      </ul>
    </div>
  );
};
